import { Directive, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { map, Observable, take } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogData } from '@portal/dialog';
import { Helper } from '@portal/util';
import { PortalConfirmBeforeChangeFn, PortalFieldTypeConfig } from '@portal/form/data-access';

export const GENERIC_FILE_CONTROL_DEPENDS = [MatDialogModule] as const;

@Directive()
export class GenericFileControlDirective extends FieldType<PortalFieldTypeConfig> {
  private readonly dialog = inject(MatDialog);

  protected get control(): FormControl<UploadFileControl | undefined | null> {
    return this.formControl;
  }

  protected get acceptMimeTypes(): string[] {
    return this.props.acceptMimeTypes || [];
  }

  protected removeFile(file: UploadFileModel) {
    const confirmBeforeChange = this.props.confirmBeforeChange;

    if (!confirmBeforeChange) {
      this.removeFileById(file.id);
      return;
    }

    let confirmFn: PortalConfirmBeforeChangeFn = () => this.openConfirmDialog();

    if (typeof confirmBeforeChange === 'function') {
      confirmFn = () => confirmBeforeChange(file);
    }

    confirmFn()
      .pipe(take(1))
      .subscribe(confirm => confirm && this.removeFileById(file.id));
  }

  private openConfirmDialog(): Observable<boolean> {
    return this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData, boolean>(ConfirmDialogComponent, {
        data: { dialogContent: 'confirmBeforeChange', button: { confirm: { label: 'Remove' } } },
        panelClass: '!max-w-md',
      })
      .afterClosed()
      .pipe(map((confirm: unknown) => Helper.toBoolean(confirm)));
  }

  private removeFileById(id: string): void {
    if (this.control.value?.has(id)) {
      this.control.value?.delete(id);
      this.control.setValue(this.control.value);
    }
  }
}
